import { XCFieldDefinitionType } from "@robe/core-types";

export const resolveIsFileField = (type: XCFieldDefinitionType) =>
  type === "Xcore.XcoreContent.Models.FieldDefinitions.FileFieldDefinition" ||
  type === "Xcore.XcoreContent.Models.FieldDefinitions.ImageFieldDefinition" ||
  type === "Xcore.XcoreContent.Models.FieldDefinitions.VideoFieldDefinition";

/** If value is array return first array item, otherwise return value */
export const only = <T>(a: T | readonly T[]): T => (Array.isArray(a) ? a[0] : a);

const numberRegex = /^[+-]?\d+(\.\d+)?$/;

export const parseStringQueryToNumber = (value: string | string[] | undefined): number | number[] | undefined => {
  if (value === undefined) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.filter((val) => numberRegex.test(val)).map(Number);
  }

  if (!numberRegex.test(value)) {
    return undefined;
  }

  return parseFloat(value);
};

export const isNil = (x: any): x is null | undefined => x === null || x === undefined;

export const capitalize = (s: string) => s[0].toLocaleUpperCase() + s.slice(1);
